/** Keep automatic chat updates from scrolling the surrounding canvas/page. */
export function scrollChatToLatest(container: HTMLElement | null) {
  container?.scrollTo({ top: container.scrollHeight, behavior: 'smooth' });
}

export function focusChatInput(input: HTMLElement | null) {
  input?.focus({ preventScroll: true });
}
